// extracted by mini-css-extract-plugin
export default {"ladder-svg":"LadderBoard_ladder-svg__xQJEO","ladder-empty":"LadderBoard_ladder-empty__YkLtx"};